import {
  Card,
  Divider,
  Grid,
  Table,
  TableBody,
  TableHead,
  Typography,
  IconButton,
  Pagination,
  CardContent,
  TableContainer,
  TextField,
  Button,
  Box
} from '@mui/material'
import { Visibility as VisibilityIcon } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import BusinessInfoDrawer from './business/businessInfoDrawer'
import { StyledTableCell, StyledTableRow } from '../../utils/ui_utils'
import { useFetchAllBusiness } from '../../modules/business/businessHooks'

export var AllBusiness = function () {
  const [data, setData] = useState([])
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [pagecount, setPageCount] = useState(1)
  const [goToPageInput, setGoToPageInput] = useState('')
  const [businessInfoDrawerVisibility, setBusinessInfoDrawerVisibility] =
    useState(false)
  const {
    fetchAllBusinessData,
    fetchAllBusinessError,
    fetchAllBusinessLoading,
    fetchAllHostBusiness
  } = useFetchAllBusiness()

  const handlePageChange = async (event, value) => {
    setPage(value)
    let payload = {
      pageNumber: value,
      limit: limit
    }
    await fetchAllHostBusiness(payload)
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (value === '' || /^\d+$/.test(value)) {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNum = parseInt(goToPageInput, 10)
    if (pageNum >= 1 && pageNum <= pagecount) {
      handlePageChange(null, pageNum)
      setGoToPageInput('')
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit()
    }
  }

  const pageCount = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCount(count)
  }

  useEffect(() => {
    let payload = {
      pageNumber: page,
      limit: limit
    }
    fetchAllHostBusiness(payload)
  }, [])

  useEffect(() => {
    if (Object.keys(fetchAllBusinessData).length > 0) {
      pageCount(fetchAllBusinessData.total)
    }
  }, [fetchAllBusinessData])

  if (fetchAllBusinessError) return <p>Error!</p>
  if (fetchAllBusinessLoading) return <p>Loading...</p>
  return (
    <>
      <Helmet title="All Business" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item xs={9} md={6}>
          <Typography variant="h4" gutterBottom display="inline">
            Businesses
          </Typography>
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: 5 }} />
      {!fetchAllBusinessLoading && fetchAllBusinessData && (
        <Grid container spacing={10} sx={{ paddingTop: 5 }}>
          <Grid item md={8}>
            <Card raised sx={{ borderRadius: 3 }}>
              <CardContent sx={{ flexGrow: 1 }}>
                <TableContainer component={Card}>
                  <Table size="small">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>Name</StyledTableCell>
                        <StyledTableCell>Telephone</StyledTableCell>
                        <StyledTableCell> GSTN</StyledTableCell>
                        <StyledTableCell>City</StyledTableCell>
                        <StyledTableCell>Address</StyledTableCell>
                        <StyledTableCell>PIN</StyledTableCell>
                        <StyledTableCell>Business Code</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {fetchAllBusinessData.data?.map((row, i) => (
                        <StyledTableRow
                          key={i}
                          hover
                          onClick={() => {
                            setData(row)
                            setBusinessInfoDrawerVisibility(true)
                          }}
                        >
                          <StyledTableCell sx={{ minWidth: 200 }}>
                            {row.name}
                          </StyledTableCell>
                          <StyledTableCell>{row.telephone}</StyledTableCell>
                          <StyledTableCell>{row.gstn}</StyledTableCell>
                          <StyledTableCell>{row.city}</StyledTableCell>
                          <StyledTableCell>{row.address}</StyledTableCell>
                          <StyledTableCell>{row.pin}</StyledTableCell>
                          <StyledTableCell>
                            {/* <IconButton
                            size="small"
                            color="primary"
                            component="span"
                            onClick={() => {
                              setData(row)
                              setBusinessInfoDrawerVisibility(true)
                            }}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>{' '} */}
                            {row.business_code}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
              {pagecount > 1 && (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    p: 2,
                    backgroundColor: 'grey.50',
                    borderRadius: 1
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      width: '100%'
                    }}
                  >
                    <Pagination
                      count={pagecount}
                      page={page}
                      color="secondary"
                      size="small"
                      boundaryCount={2}
                      siblingCount={0}
                      showFirstButton
                      showLastButton
                      onChange={handlePageChange}
                      sx={{
                        '& .MuiPaginationItem-root': {
                          transition: 'all 0.2s ease-in-out'
                        }
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: 1.5,
                      backgroundColor: 'white',
                      p: 2,
                      borderRadius: 1,
                      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                      transition: 'box-shadow 0.2s ease-in-out',
                      '&:hover': {
                        boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                      }
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ color: 'text.secondary', fontWeight: 500 }}
                    >
                      Jump to
                    </Typography>
                    <TextField
                      size="small"
                      value={goToPageInput}
                      onChange={handleGoToPageChange}
                      onKeyPress={handleGoToPageKeyPress}
                      placeholder="Page"
                      sx={{
                        width: '80px',
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: 'white',
                          transition: 'all 0.2s ease-in-out',
                          '& fieldset': {
                            borderColor: 'grey.300',
                            borderWidth: '1px'
                          },
                          '&:hover fieldset': {
                            borderColor: 'secondary.main',
                            borderWidth: '1.5px'
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'secondary.main',
                            borderWidth: '2px',
                            boxShadow: '0 0 0 3px rgba(156, 39, 176, 0.1)'
                          }
                        },
                        '& .MuiOutlinedInput-input': {
                          textAlign: 'center',
                          fontWeight: 500,
                          padding: '7px 8px',
                          height: '20px',
                          lineHeight: '20px'
                        }
                      }}
                    />
                    <Typography
                      variant="body2"
                      sx={{ color: 'text.secondary', fontWeight: 400 }}
                    >
                      of {pagecount}
                    </Typography>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={handleGoToPageSubmit}
                      disabled={
                        !goToPageInput ||
                        parseInt(goToPageInput, 10) < 1 ||
                        parseInt(goToPageInput, 10) > pagecount
                      }
                      sx={{
                        textTransform: 'none',
                        fontWeight: 500,
                        px: 2,
                        py: 0.75,
                        height: '34px',
                        lineHeight: 1,
                        transition: 'all 0.2s ease-in-out',
                        '&:hover': {
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 8px rgba(156, 39, 176, 0.3)'
                        },
                        '&:active': {
                          transform: 'translateY(0)'
                        }
                      }}
                    >
                      Go
                    </Button>
                  </Box>
                </Box>
              )}
            </Card>
          </Grid>
        </Grid>
      )}
      <BusinessInfoDrawer
        visible={businessInfoDrawerVisibility}
        title="Business Info"
        cancelText="Close"
        initialValues={data}
        onClose={() => setBusinessInfoDrawerVisibility(false)}
      />
    </>
  )
}
